<template>
    <div>
      <div v-if="addresses.length">
      <div class="profile-block__item" v-for="address in addresses" :key="address.ID">
        <div class="profile-block__row row">
          <div class="profile-block__col col-3 col-xs-12">
            <div class="profile-block__name title-h4">{{ address.ADDRESS_NAME }}</div>
          </div>
          <div class="profile-block__col col-6 col-xs-12">
            <p v-if="address.LOCATION">{{ address.LOCATION.DISPLAY }}</p>
            <p>{{ address.ZIP ? `${address.ZIP}, ` : '' }}ул. {{address.STREET}}, д. {{address.HOUSE}}{{ address.BUILDING ? ` к. ${address.BUILDING}` : ''}}{{ address.APARTMENTS ? `, кв. ${address.APARTMENTS}` : ''}}</p>
            <p>+7 (929) 510-59-05</p>
          </div>
          <div class="profile-block__links col-3 col-xs-12">
            <p>
              <router-link :to="{name: 'delivery-address-create', params: {addressId: address.ID}}">Редактировать</router-link>
            </p>
            <p>
              <a href="" @click.prevent="deleteAddress(address.ID)">Удалить</a>
            </p>
          </div>
        </div>
      </div>
      </div>
      <p v-if="addressesLoaded && !addresses.length">У вас нет ни одного сохраненного адреса доставки</p>
      <p v-if="!addressesLoaded">Загрузка адресов...</p>
      <div class="profile-block__add">
        <router-link :to="{name: 'delivery-address-create'}">Добавить адрес</router-link>
      </div>
    </div>
</template>

<script>
    import api from '@/api/address'

    export default {
        name: 'ProfileAddresses',
        data: function () {
          return {
            addresses: {
              type: Array,
              default: function () {
                return [];
              }
            },
            addressesLoaded: false,
          };
        },
        components: {
        },
        computed: {

        },
        watch: {

        },
        methods: {
          deleteAddress(addressId) {
            api.delete(addressId, () => {
              api.loadForCurrentUser(addresses => {this.addresses = addresses.data.addresses;});
            });
          }
        },
        mounted() {
          api.loadForCurrentUser(addresses => {
            this.addresses = addresses.data.addresses;
            this.addressesLoaded = true;
          });
        }
    }
</script>